import { createSelector } from "reselect";

export const getGameState = gameData => gameData.gameState; 